module.exports = __webpack_public_path__ + "media/images/sharestickers_logo-ad36ce3e33ef26b17f83a6734f7e1bd6.png";